import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Contact from "../views/Contact.vue";
import Press from "../views/Press.vue";
import Music from "../views/Music.vue";
import Sculptures from "../views/Sculptures.vue";
import TrompeLoeil from "../views/TrompeLoeil.vue";
import Stories from "../views/Stories.vue";
import SculpturesPdf from "../views/SculpturesPdf.vue";
import SculpturesArticles from "../views/SculpturesArticles.vue"
import SculpturesOtherCriticisms from "../views/SculpturesOtherCriticisms.vue"
import TrompeLoeilPdf from "../views/TrompeLoeilPdf.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "Home",
      requiresAuth: false,
    },
  },
  {
    path: "/",
    name: "Contact",
    component: Contact,
    meta: {
      title: "Contact",
      requiresAuth: false,
    },
  },
  {
    path: "/",
    name: "TrompeLoeilPdf",
    component: TrompeLoeilPdf,
    meta: {
      title: "TrompeLoeilPdf",
      requiresAuth: false,
    },
  },
  {
    path: "/",
    name: "TrompeLoeil",
    component: TrompeLoeil,
    meta: {
      title: "TrompeLoeil",
      requiresAuth: false,
    },
  },
  {
    path: "/",
    name: "Sculptures",
    component: Sculptures,
    meta: {
      title: "Sculptures",
      requiresAuth: false,
    },
  },
  {
    path: "/",
    name: "SculpturesPdf",
    component: SculpturesPdf,
    meta: {
      title: "SculpturesPdf",
      requiresAuth: false,
    },
  },
  {
    path: "/",
    name: "SculpturesArticles",
    component: SculpturesArticles,
    meta: {
      title: "SculpturesArticles",
      requiresAuth: false,
    },
  },
  {
    path: "/",
    name: "SculpturesOtherCriticisms",
    component: SculpturesOtherCriticisms,
    meta: {
      title: "SculpturesOtherCriticisms",
      requiresAuth: false,
    },
  },
  {
    path: "/",
    name: "Music",
    component: Music,
    meta: {
      title: "Music",
      requiresAuth: false,
    },
  },
  {
    path: "/",
    name: "Press",
    component: Press,
    meta: {
      title: "Press",
      requiresAuth: false,
    },
  },
  {
    path: "/",
    name: "Stories",
    component: Stories,
    meta: {
      title: "Stories",
      requiresAuth: false,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});



router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title} | Viscuso`;
  next();
});



export default router;
